var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.275 2l.725.725-4 3.999V8a2 2 0 01-3.005 1.73l-.723.723a3 3 0 004.723-2.276L11 8V7h1v1a4 4 0 01-3.5 3.969V15h2a.5.5 0 110 1h-5a.5.5 0 110-1h2v-3.03a3.98 3.98 0 01-1.943-.802L2.725 14 2 13.275 13.275 2zM5 7v1c0 .276.037.543.107.796l-.783.783A3.987 3.987 0 014 8V7h1zm4 .724L7.755 8.97a1.002 1.002 0 001.238-.853L9 8v-.276zM8 0a2 2 0 012 2v1.902l-1 1V2a1 1 0 00-1.993-.117L7 2v4.902L6 7.903V2a2 2 0 012-2z",
    fill: "#596266"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneMuted);
export default __webpack_public_path__ + "static/media/MicrophoneMuted.30d0a288.svg";
export { ForwardRef as ReactComponent };